export { default as AlmacenesPadreTab } from "./AlmacenesPadreTab";

